import type { RoofEdge, InstallArea, Panel } from "@logic/lib/design"
import type { Node2d } from "@logic/lib/mesh"
import type { Index1ToMany } from "@logic/lib/utils"
import type { RecoilState } from "recoil"

import type { RecoilStateFamily } from "~/components/ui"

import { areaIndex, findAreaState } from "./areas"
import { edgeIndex, findEdgeState } from "./edges"
import { findNodeState, nodeIndex } from "./nodes"
import { findPanelState, panelIndex } from "./panels"
import { areasOfPanelsIndexState } from "./relations"

export * from "./nodes"
export * from "./edges"
export * from "./areas"

export type Elements = {
  NODE: Node2d
  EDGE: RoofEdge
  AREA: InstallArea
  PANEL: Panel
}

// These lookup tables are built lazily: this barrel sits in a circular-import
// cluster with the element/phase/transaction modules, so referencing the
// atoms at module scope throws a TDZ ReferenceError whenever the bundler
// happens to evaluate this file before the atom declarations run.
export const getElementIndices = (): Record<
  keyof Elements,
  RecoilState<string[]>
> => ({
  NODE: nodeIndex,
  EDGE: edgeIndex,
  AREA: areaIndex,
  PANEL: panelIndex,
})

export const getElementFamilies = (): {
  [Key in keyof Elements]: RecoilStateFamily<Elements[Key], string>
} => ({
  NODE: findNodeState,
  EDGE: findEdgeState,
  AREA: findAreaState,
  PANEL: findPanelState,
})

export const getElementRelations1ToMany = (): Record<
  `AREA_PANEL`,
  RecoilState<Index1ToMany<string, string>>
> => ({
  AREA_PANEL: areasOfPanelsIndexState,
})
